import React from 'react'
import { CardDesk } from './card-desk'
import { CardMob } from './card-mob'
import { useMatchMedia } from '@rst/libs-ts'

export const CardPreloader = (props: any) => {
	const sm = useMatchMedia(x => x.less.sm)
	return !sm ? <CardDesk {...props} /> : <CardMob {...props} />
}
